import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/industries/profile/loading';

export const Route = createFileRoute('/_private/settings/industries/$id')({
  pendingComponent: Loading,
});
